import React from "react";
import { Box, Typography, IconButton } from "@mui/material";

const TitleContainer = ({ icon, buttonIcon, title, onClick, ...props }) => {
  return (
    <Box
      sx={{
        width: 292,
        height: 25,
        color: "#fff",
        backgroundImage: "url(assets/background/titlebg.svg)",
        backgroundSize: "cover",
        display: "flex",
        alignItems: "center",
        pl: 2,
        ...props.sx,
      }}
    >
      <img src={icon} style={{ height: 19 }} alt={title} />
      <Typography component="span" sx={{ ml: 1, mr: 1 }}>
        {title}
      </Typography>
      {onClick && (
        <IconButton aria-label="container-action" size="small" onClick={onClick} sx={{ p: 0 }}>
          {buttonIcon && <img src={buttonIcon} style={{ height: 19 }} alt={title} />}
        </IconButton>
      )}
    </Box>
  );
};

export default TitleContainer;
